'use strict';

const React = require('react');
const ReactDOM = require('react-dom');
const root = require('bunsen/helpers/windowCheck');
const provideContext = require('fluxible-addons-react/provideContext');
const VisitCountModel = require('../../global/tracking/models/VisitCountModel');
const {localStorage} = require('dibs-browser-storage');

const Introduction = provideContext(require('./Introduction'));
const introductionTracking = require('./introduction-trackingActions');

const sessionLimit = 3;

const introductionHelper = {

    /**
     * init introduction banner
     */
    init(payload = {}) {
        const {context, isEnabled} = payload;
        const visitCountModel = new VisitCountModel();
        const sessionCount = visitCountModel.get('session');

        if (isEnabled && sessionCount <= sessionLimit) {
            this._initIntroduction({ context });
        }
    },

    /**
     * shows introduction banner for 3 sessions
     */
    _initIntroduction(payload = {}) {
        const {context} = payload;
        const banner = root.document.querySelectorAll('.js-introduction-container')[0];
        const dibsIntroduction = !localStorage.getItem('dibsIntroduction');

        if (banner && dibsIntroduction) {
            ReactDOM.render(
                React.createElement(Introduction, { context: context.getComponentContext() }),
                banner
            );

            context.executeAction(introductionTracking.trackBannerEcommerce);
        }
    }
};

module.exports = introductionHelper;



// WEBPACK FOOTER //
// ./assets/js/components/Introduction/introduction-helper.es.js